/**
 * Sign-up route — /sign-up
 *
 * Public (unauthenticated) route. The auth gate in __root.tsx lets /sign-in and
 * /sign-up through to their own components instead of rendering the sign-in
 * screen inline. Keeps registration on app.aelo.cloud (same origin) so the
 * i18n language and the post-signup redirect (/onboarding) are preserved.
 */
import { createFileRoute } from '@tanstack/react-router';
import { SignUpScreen } from '@/features/auth/SignUpScreen';

export const Route = createFileRoute('/sign-up')({
  component: SignUpScreen,
});
